import { Grid } from '@mui/material';

import { SubHeader } from '@components';
import NewSearchField from 'components/filters/NewFiltersParams/NewSearchField';

export function MovementByScreenSubHeader() {
  return (
    <SubHeader>
      <Grid container>
        <Grid item xs={12}>
          <NewSearchField
            name="search"
            currentResultLength={0}
            placeholder="Buscar por funcionalidade"
            typingSearch
          />
        </Grid>
      </Grid>
    </SubHeader>
  );
}
